import React from 'react';
import {
    Collapse, Tag, List, Descriptions, Typography, Spin
} from 'antd';
import { getFgReviewProjectList, getFgBudgetsReviewForYear } from '../util/APIUtils';
import { formatCurrency } from '../util/Helpers';
import FgReviewModal from './FgReviewModal';
import { Link } from 'react-router-dom';
import CommentList from './CommentList';
import FgBudgetReview from '../fg_budget/FgBudgetReview';

const { Title } = Typography;

function FgReviewProjectList({ currentUser, fgId }) {
    const {
        isLoading: isLoadingProjects,
        error: errorProjects,
        data: projectData = [],
        refetch
    } = getFgReviewProjectList(fgId)((json) => json, {
        refetchInterval: 30000,
    });

    const {
        isLoading: isLoadingBudgets,
        error: errorBudgets,
        data: budgetData = []
    } = getFgBudgetsReviewForYear()((json) => json);

    if (isLoadingProjects || isLoadingBudgets) {
        return <Spin tip="Wird geladen ..." />;
    }

    if (errorProjects || errorBudgets) {
        return <p>Error Wird geladen ..</p>;
    }

    const getStatusTag = (status) => {
        switch ((status || '').toLowerCase()) {
            case 'ok': return <Tag color="#87d068" style={{ float: 'right', width: '100px' }}>OK</Tag>;
            case 'abgelehnt': return <Tag color="#f50" style={{ float: 'right', width: '100px' }}>Abgelehnt</Tag>;
            case 'zurückgestellt': return <Tag color="#ffc300" style={{ float: 'right', width: '100px' }}>Zurückgestellt</Tag>;
            default: return <Tag style={{ float: 'right', width: '100px' }}>Kein Status</Tag>;
        }
    };

    const filteredProjects = fgId === '0'
        ? projectData
        : projectData.filter(p => `${p.priorityFG}` === `${fgId}`);

        console.log(budgetData)

    const filteredBudgets = fgId === '0'
        ? budgetData
        : budgetData.filter(b => `${b.fachGroupId}` === `${fgId}`);

    const cropMap = new Map();

    filteredProjects.forEach(project => {
        if (!cropMap.has(project.cropId)) {
            cropMap.set(project.cropId, {
                cropId: project.cropId,
                cropName: project.cropName,
                projects: [],
            });
        }
        cropMap.get(project.cropId).projects.push(project);
    });

    console.log(filteredBudgets)

    filteredBudgets.forEach(budget => {
        if (!cropMap.has(budget.cropId)) {
            cropMap.set(budget.cropId, {
                cropId: budget.cropId,
                cropName: budget.cropName,
                projects: [],
            });
        }
    });



    const panels = Array.from(cropMap.values()).sort((a, b) =>
        a.cropName.localeCompare(b.cropName)
    );

    const keys = panels.map((p) => p.cropName);

    return (
        <Collapse defaultActiveKey={keys} style={{ borderLeft: 'none', borderRight: 'none' }}>
            {panels.map((panel) => (
                <Collapse.Panel key={panel.cropName} header={<b>{panel.cropName}</b>}>
                    <FgBudgetReview cropId={panel.cropId} />
                    <br />

                    {panel.projects.length > 0 ? (
                        <>
                            <Title level={5} style={{ backgroundColor: '#ccc', color: 'black', padding: '10px' }}>
                                Projekte Evaluation
                            </Title>
                            {panel.projects.map((item) => (
                                <List.Item key={item.projectDetailId}>
                                    <List.Item.Meta
                                        title={
                                            <>
                                                <b>
                                                    <Link to={{
                                                        pathname: `/project/detail/${item.projectId}`,
                                                        state: { id: item.projectId }
                                                    }}>
                                                        {item.projectNumber} - {item.projectTitle}
                                                    </Link>
                                                </b>
                                                {item.valid && (
                                                    <FgReviewModal
                                                        projectDetailId={item.projectDetailId}
                                                        refetch={refetch}
                                                        comment={item.commentFG}
                                                        approvedAmount={item.amountFG}
                                                        approvalStatus={item.statusFG}
                                                        projectNumber={item.projectNumber}
                                                    />
                                                )}
                                                {getStatusTag(item.statusFG)}
                                            </>
                                        }
                                        description={
                                            <Descriptions
                                                span={3}
                                                size='small'
                                                bordered
                                                style={{ borderLeft: 'none', borderRight: 'none' }}
                                            >
                                                <Descriptions.Item span={3} label="Züchter">{item.breederName}</Descriptions.Item>
                                                <Descriptions.Item span={3} label="Kulturart">{item.cropName}</Descriptions.Item>
                                                <Descriptions.Item span={1} label="Betrag"><b>{formatCurrency(item.amount)}</b></Descriptions.Item>
                                                <Descriptions.Item span={2} label="Betrag FG"><b>{formatCurrency(item.amountFG)}</b></Descriptions.Item>
                                                <Descriptions.Item span={3} label="Kommentar FG leiter" style={{ backgroundColor: '#fffceb' }}>
                                                    {item.commentFG}
                                                </Descriptions.Item>
                                                <Descriptions.Item span={3} label="Kommentar" style={{ backgroundColor: '#f6fff8' }}>
                                                    <CommentList currentUser={currentUser} itemId={item.projectDetailId} />
                                                </Descriptions.Item>
                                            </Descriptions>
                                        }
                                    />
                                </List.Item>
                            ))}
                        </>
                    ) : (
                        <p style={{ fontStyle: 'italic', color: '#888' }}>Keine Projekte vorhanden.</p>
                    )}
                </Collapse.Panel>
            ))}
        </Collapse>
    );
}

export default FgReviewProjectList;
